export const statusCode =
  // Generic Success 1-20
  {
    1: 'İşlem başarılı.',
    2: 'Kaydetme işlemi başarılı.',
    3: 'Güncelleme işlemi başarılı.',
    4: 'Silme işlemi başarılı.',
    5: 'Detay görüntüleme işlemi başarılı.',
    6: 'Listeleme işlemi başarılı.',
    7: 'Dosya uzantısı *.jpeg, *.jpg ya da *.png olmalıdır.',
    8: 'Dosya boyutu aşıldı.',
    9: 'Geçersiz il bilgisi bulunmaktadır.',
    10: 'Geçersiz ilçe bilgisi bulunmaktadır.',
    11: 'Geçersiz bölge bilgisi bulunmaktadır.',
    12: 'Geçersiz eczane bilgisi bulunmaktadır',
    13: 'Dosya bulunamadı.',
    14: 'Geçersiz sipariş bilgisi bulunmaktadır.',
    15: 'Geçersiz ilaç bilgisi bulunmaktadır.',
    16: 'Geçersiz kampanya bilgisi bulunmaktadır.',
    17: 'Token bulunamadı.',
    18: 'Kullanıcı bulunamadı.',
    19: "Kullanıcı token'ı doğrulanırken hata oluştu.",
    20: 'An error was occured.',
    21: 'Şifre güncelleme işleminde hata oluştu.',
    22: 'SMS gönderirken hata oluştu.',
    23: 'E-posta gönderirken hata oluştu.',
    24: 'Push bildirimi gönderirken hata oluştu.',
    25: 'E-posta ve SMS gönderirken hata oluştu.',
    26: 'Geçerli kampanya kaydı bulunamadı.',
    27: 'Geçerli il kaydı bulunamadı.',
    28: 'Geçerli ilçe kaydı bulunamadı.',
    29: 'Geçerli bölge kaydı bulunamadı.',
    30: 'Geçerli ilaç kaydı bulunamadı.',
    31: 'Geçerli eczane kaydı bulunamadı.',
    32: 'Eczane TURP eczanesi değildir.',
    33: "Varolan kullanıcıların 'telefon' bilgisi kullanılamaz.",
    34: 'Kullanıcı hesap silme işleminde hata oluştu.',
    35: "Varolan kullanıcıların 'eposta' bilgisi kullanılamaz.",
    36: 'Kullanıcı hesap güncelleme işleminde hata oluştu.',
    37: 'Kullanıcı hesap oluşturma işleminde hata oluştu.',
    38: 'Şifre ve şifre onay aynı olmalıdır.',
    39: 'Geçersiz parametre(ler).',
    40: 'Geçersiz sözleşme bilgisi bulunmaktadır.',
    41: 'Validasyon hatası.',
    42: 'Bir hata oluştu. Sistem yöneticisine başvurunuz.',
    43: 'Geçersiz kullanıcı bilgisi bulunmaktadır.',
    44: 'Tarih aralığı geçersizdir.',
    45: 'Geçersiz eczane kullanıcı bilgisi bulunmaktadır.',
    46: 'Roller listelenirken hata oluştu.',
    47: 'Atanmak için geçersiz ya da tekrarlı roller bulunmaktadır.',
    48: 'Geçerli eczane kullanıcı kaydı bulunamadı.',
    49: 'Kullanıcıya rol atama işleminde hata oluştu.',
    50: 'Eczane durumu zaten pasiftir.',
    51: 'Eczane durumu zaten aktiftir.',
    52: 'Bu işlem için yetkiniz bulunmamaktadır.',
    53: 'Yetkili eczane bulma işleminde hata oluştu.',
    54: 'Kampanya görseli bulunamadı.',
    55: 'Geçersiz müşteri destek formu bilgisi bulunmaktadır.',
    56: 'İlaç görseli bulunamadı.',
    57: 'Geçersiz sözleşme versiyon bilgisi bulunmaktadır.',
    58: 'Sözleşme listesi boştur.',
    59: 'Geçersiz uygulama versiyon bilgisi bulunmaktadır.',
    60: 'Geçersiz nöbetçi eczane bilgisi bulunmaktadır.',
    61: 'Eski günler nöbetçi eczaneler için eklenemez.',
    62: 'Geçersiz eczane destek formu bilgisi bulunmaktadır.',
    63: 'Dosya uzantısı *.xlsx, *.xls olmalıdır.',
    64: 'Dosya uzantı tipi geçersizdir.',
    65: 'Hatalı dosya bulunmaktadır.',
    66: 'Geçerli sistem kullanıcı kaydı bulunamadı.',
    67: 'Eczane listesi geçersiz ya da boştur.',
    68: 'Geçerli TURP eczanesi bulunamadı.',
    69: 'Geçerli kampanya-eczane bulunamadı.',
    70: 'Kampanya kodu üretmeyi tekrar deneyiniz.',
    71: 'Geçersiz durum bilgisi bulunmaktadır.',
    72: 'Kampanya durumu zaten pasiftir.',
    73: 'Kampanya durumu zaten aktiftir.',
    74: 'Kampanyanın aktifleştirilmesi için kampanyaya dahil olan en az bir eczane olmalıdır.',
    75: 'Geçerli müşteri destek formu kaydı bulunamadı.',
    76: 'Eczane zaten TURP eczanesidir.',
    77: 'Eksik ya da hatalı kolonlar bulunmaktadır.',
    78: 'İçe aktarılacak eczane kaydı bulunmamaktadır.',
    79: 'Geçerli eczane destek formu kaydı bulunamadı.',
    80: 'Eski ya da varolan günler nöbetçi eczaneler için eklenemez.',
    81: 'Geçerli nöbetçi eczane kaydı bulunamadı.',
    82: 'Eski nöbetçi eczane kayıtları silinemez.',
    83: "Varolan bir ilacın 'barkot numarası' tekrar kullanılamaz.",
    84: 'Varolan bir ilacın adı tekrar kullanılamaz.',
    85: 'İlaç durumu zaten pasiftir.',
    86: 'İlaç durumu zaten aktiftir.',
    87: 'İçe aktarılacak ilaç kaydı bulunmamaktadır.',
    88: 'Geçerli sözleşme kaydı bulunamadı.',
    89: 'Varolan versiyon numarası ile yeni kayıt oluşturulamaz.',
    90: 'Geçerli sözleşme versiyon kaydı bulunamadı.',
    91: 'Varolan versiyon numarası ile başka bir kayıt güncellenemez.',
    92: 'Sözleşme versiyonu zaten yayındadır.',
    93: 'Sözleşme versiyonu zaten yayında değildir.',
    94: 'Varolan sözleşme adı ile yeni kayıt oluşturulamaz.',
    95: 'Varolan sözleşme adı ile başka bir kayıt güncellenemez.',
    96: 'Sözleşme durumu zaten pasiftir.',
    97: 'Sözleşme durumu zaten aktiftir.',
    98: 'Sözleşme listesi geçersizdir.',
    99: 'İçe aktarılacak il kaydı bulunmamaktadır.',

    // Generic Exceptions 100-199
    100: "Varolan bir ilin 'plakası' tekrar kullanılamaz.",
    101: "Varolan bir ilin 'adı' tekrar kullanılamaz.",
    102: "Varolan bir ilin 'adı' ve ilçe adı tekrar kullanılamaz.",
    103: 'Varolan bir ilçenin adı ve bölge adı tekrar kullanılamaz.',
    104: 'Geçerli uygulama versiyon kaydı bulunamadı.',
    105: 'Varolan bir uygulama versiyonun işletim sistemi ve versiyonu tekrar kullanılamaz.',
    106: 'Veri işlemede/çekmede hata oluştu. Lütfen sistem yöneticisine başvurunuz.',
    107: 'Kullanıcı rol bilgisi alınırken hata oluştu.',
    108: 'Varolan kullanıcıların "T.C Kimlik numarası" bilgisi kullanılamaz.',

    // PluashAuth Exceptions 300-399
    300: 'Kullanıcı yetkili değil.',

    // Authentication-Authorization Exceptions 400-499
    401: 'Token bulunamadı.',
    403: 'Yetki hatası!'
  };
